import { useState, useEffect } from 'react';
import { reviewAPI } from '../../services/api';
import { Star, Check, X, Trash2, MessageSquare } from 'lucide-react';

export default function ReviewsAdmin() {
    const [reviews, setReviews] = useState([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [pages, setPages] = useState(1);
    const [filter, setFilter] = useState('all');
    const [loading, setLoading] = useState(false);

    const load = async () => {
        setLoading(true);
        try {
            const params = { page, limit: 20 };
            if (filter !== 'all') params.status = filter;
            const res = await reviewAPI.adminGetAll(params);
            setReviews(res.data.reviews || []);
            setTotal(res.data.total || 0);
            setPages(res.data.pages || 1);
        } catch (e) { console.error(e); }
        setLoading(false);
    };

    useEffect(() => { load(); }, [page, filter]);

    const handleApprove = async (id, approve) => {
        try {
            await reviewAPI.adminApprove(id, { isApproved: approve });
            load();
        } catch (e) { console.error(e); }
    };

    const handleDelete = async (id) => {
        if (!confirm('Bu yorumu silmek istediğinize emin misiniz?')) return;
        try {
            await reviewAPI.adminDelete(id);
            load();
        } catch (e) { console.error(e); }
    };

    return (
        <div className="admin-page">
            <div className="admin-page-header">
                <h1><MessageSquare size={24} /> Ürün Yorumları</h1>
                <span className="admin-count">{total} yorum</span>
            </div>

            <div className="review-admin-filters">
                {['all', 'pending', 'approved'].map(f => (
                    <button key={f} className={`ord-filter-chip ${filter === f ? 'active' : ''}`} onClick={() => { setFilter(f); setPage(1); }}>
                        {f === 'all' ? 'Tümü' : f === 'pending' ? 'Bekleyen' : 'Onaylı'}
                    </button>
                ))}
            </div>

            {loading ? (
                <div className="loading"><div className="spinner"></div></div>
            ) : reviews.length === 0 ? (
                <div className="empty-state">
                    <MessageSquare size={48} strokeWidth={1} />
                    <h3>Yorum bulunamadı</h3>
                </div>
            ) : (
                <div className="review-admin-list">
                    {reviews.map(review => (
                        <div key={review.id} className={`review-admin-card ${review.isApproved ? 'approved' : 'pending'}`}>
                            <div className="review-admin-top">
                                <div>
                                    <strong>{review.customer?.firstName} {review.customer?.lastName}</strong>
                                    <span className="review-admin-email">{review.customer?.email}</span>
                                </div>
                                <div className="review-admin-meta">
                                    <span className={`review-admin-status ${review.isApproved ? 'approved' : 'pending'}`}>
                                        {review.isApproved ? 'Onaylı' : 'Bekliyor'}
                                    </span>
                                    <span>{new Date(review.createdAt).toLocaleDateString('tr-TR')}</span>
                                </div>
                            </div>
                            <div className="review-admin-product">
                                <span>Ürün: <strong>{review.product?.name}</strong></span>
                                {review.order && <span>Sipariş: #{review.order.orderNumber}</span>}
                            </div>
                            <div className="review-admin-stars">
                                {[1,2,3,4,5].map(s => (
                                    <Star key={s} size={16} fill={s <= review.rating ? '#fbbf24' : 'none'} color={s <= review.rating ? '#fbbf24' : '#ccc'} />
                                ))}
                            </div>
                            <p className="review-admin-comment">{review.comment}</p>
                            <div className="review-admin-actions">
                                {!review.isApproved ? (
                                    <button className="btn btn-sm" style={{background:'var(--success)', color:'#fff'}} onClick={() => handleApprove(review.id, true)}>
                                        <Check size={16} /> Onayla
                                    </button>
                                ) : (
                                    <button className="btn btn-sm btn-secondary" onClick={() => handleApprove(review.id, false)}>
                                        <X size={16} /> Onayı Kaldır
                                    </button>
                                )}
                                <button className="btn btn-sm" style={{background:'var(--danger)', color:'#fff'}} onClick={() => handleDelete(review.id)}>
                                    <Trash2 size={16} /> Sil
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {pages > 1 && (
                <div className="ord-pagination" style={{marginTop:'1.5rem'}}>
                    <div className="ord-pagination-btns">
                        {Array.from({ length: pages }, (_, i) => i + 1).map(p => (
                            <button key={p} className={page === p ? 'active' : ''} onClick={() => setPage(p)}>{p}</button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}
